module.exports = __webpack_public_path__ + "img/barMark1.36fe246d.png";